import { Injectable } from '@angular/core';
import { MessageHandlerIntl } from '@ebootis/utilities';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin } from 'rxjs';

@Injectable()
export class MessageHandlerI18n extends MessageHandlerIntl {

	public constructor(
		private m_translateService: TranslateService
	) {
		super();
		this.m_translateService.onLangChange.subscribe({
			next: (e: Event) => {
				this.getAndInitTranslations();
			}
		});
		this.getAndInitTranslations();
	}

	private getAndInitTranslations(): void {
		forkJoin(
			this.m_translateService.get('GLOBAL.MESSAGE.HTTP_STATUS.500.TEXT'),
			this.m_translateService.get('GLOBAL.MESSAGE.HTTP_STATUS.504.TEXT'),
			this.m_translateService.get('GLOBAL.MESSAGE.UNKNOWN.TEXT')
		).subscribe({
			next: (res: string[]) => {
				this.displayError500Intl = res[0];
				this.displayError504Intl = res[1];
				this.displayErrorDefaultIntl = res[2];
				this.changes.next(res);
			}
		});
	}
}
